import React from "react";
import "./NewButton.css";
import { useScreenTransition } from "../Hooks/useScreenTransition";
import { ReactComponent as ChevronLeft } from "../assets/icons/ChevronLeft.svg";
import { ReactComponent as Send } from "../assets/icons/Send.svg";
import { FreshText } from "./TranslationSafe";

const NewButton = ({
  text,
  transition,
  back,
  width = "240px",
  disabled,
  onClick,
  transitionProhibited,
  icon = true,
  whiteBtn = false,
  deleteBtn,
  smallPadding,
  sendIcon = false,
  customIcon,
  className = "",
  // A checkout Continue button while the step is incomplete: it looks as
  // usual and a click calls onBlockedClick (show what's missing) instead of
  // onClick; describedBy points at the "Still needed" line.
  blocked = false,
  onBlockedClick,
  describedBy,
  // A link that looks like the button (e.g. a document that opens in a new
  // tab with newTab): an <a href> instead of a <button>.
  href,
  newTab = false,
}) => {
  const { transitionTo } = useScreenTransition();
  const Tag = href ? "a" : "button";
  const linkProps = href
    ? { href, ...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {}) }
    : { disabled };
  const linkClass = href ? " inline-block text-center" : "";

  const handleClick = (e) => {
    if (href) {
      // The link opens the page; onClick (if any) only does its extra.
      onClick && onClick(e);
      return;
    }
    if (blocked) {
      onBlockedClick && onBlockedClick(e);
      return;
    }
    if (onClick) {
      onClick(e);
    } else {
      if (!transitionProhibited && transition) {
        transitionTo(transition, e);
      }
    }
  };
  if (back) {
    return (
      <Tag {...linkProps} className={`${className} backToTypeOrder ${smallPadding ? "btnSmallPadding" : ""}${linkClass}`} onClick={handleClick} style={{width: window.innerWidth < 800 ? "fit-content" : width, backgroundColor: whiteBtn ? "#fff" : "#f3f3f3", 
      borderColor: whiteBtn ? "#E6E7E9" : "#030F23", color: whiteBtn ? "#030F23" : "#030F23"}}>
        {window.innerWidth > 900 ? icon ? customIcon ?  customIcon : (
          <ChevronLeft className="backToOrderIcon" />
        ) : sendIcon ? <Send /> : null : null}
        {typeof text === "string" ? <FreshText>{text}</FreshText> : text}
      </Tag>
    );
  }

  return (
    <Tag
      {...linkProps}
      aria-describedby={blocked && !disabled && describedBy ? describedBy : undefined}
      style={{ width: width }}
      className={`${className} mainOrderTypeOptionButton ${deleteBtn ? "mainOrderTypeDeleteButton" : ""} ${smallPadding ? "btnSmallPadding" : ""}${blocked && !disabled ? " isBlocked" : ""}${linkClass}`}
      onClick={handleClick}
    >
      {icon && customIcon &&  customIcon}
      {typeof text === "string" ? <FreshText>{text}</FreshText> : text}
    </Tag>
  );
};

export default NewButton;
